// Set your public social URLs here. Leave blank to hide an icon.
export default {
  facebook: 'https://www.facebook.com/share/1B7GQbCgnL/?mibextid=wwXIfr',
  linkedin: 'https://www.linkedin.com/company/socialmaniacs',
  instagram: 'https://www.instagram.com/socialmaniacs.in',
};
